import type React from 'react'
import {useNavigate} from 'react-router-dom'
import {Button} from '@/components/GDS/atoms/Button'
import BaseCard from '@/components/common/BaseCard'

interface NotFoundProps {
  title?: string
  message?: string
  fallbackPath?: string
  fallbackLabel?: string
}

/**
 * NotFound component for displaying error messages when an entity is not found,
 * deleted, or the user doesn't have access to it.
 */
const NotFound: React.FC<NotFoundProps> = ({
  title = 'Not Found',
  message = 'The page or resource you are looking for does not exist or has been removed.',
  fallbackPath = '/',
  fallbackLabel = 'Go to Home',
}) => {
  const navigate = useNavigate()

  const handleNavigate = () => {
    navigate(fallbackPath)
  }

  return (
    <div className="mt-4 w-full">
      <BaseCard title="">
        <div className="flex flex-col items-center justify-center py-16 text-center">
          <h1 className="text-title-large mb-2">{title}</h1>
          <p className="text-body-base mb-6 max-w-md">{message}</p>
          <Button variant="primary" size="medium" text={fallbackLabel} onClick={handleNavigate} />
        </div>
      </BaseCard>
    </div>
  )
}

export default NotFound
